import { ButtonGroup, Td, Text } from "@chakra-ui/react"
import { Heading, IconButton, Profile, Row, Searchable, Section, Stock, Table, Tag } from "components"
import { useProductStocks } from "hooks"
import { useState } from "react"
import { useNavigate, useParams } from "react-router"

export default function Stocks(){

    const params = useParams()
    const navigate = useNavigate()
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const stock = useProductStocks(params?.id, page, term)
    const columns = [
        { children: 'Núcleo' },
        { children: 'Estoque' },
        { children: 'Disponível', isNumeric: true },
        { children: 'Bonihub' },
        { children: 'Disponível Bonihub', isNumeric: true },
    ]

    return(
    <>
    <Section title="Estoque do produto em núcleos">
        <ButtonGroup size="xs">
            <IconButton label="Atualizar" icon="refresh" isLoading={stock.isFetching} onClick={stock.refetch} />
        </ButtonGroup>
    </Section>

    <Searchable placeholder="Procurar pelo nome do núcleo..." value={term} setValue={setTerm} />

    <Table columns={columns} setPage={setPage} meta={stock.data?.meta} loading={stock.isLoading}>
        { stock.data?.data?.map(item => <Item key={item.id} data={item} opacity={item.stock <= 0 ? 0.5 : 1} onClick={() => navigate(`/distributors/${item.distributor_id}`)} />)}
    </Table>
    </>
    )
}

const Item = ({ data, ...props }) => {
    const bonihubStock    = data.bonihub_stock    ?? 0
    const bonihubReserved = data.bonihub_reserved ?? 0
    const bonihubAvailable = Math.max(bonihubStock - bonihubReserved, 0)

    return (
    <Row {...props}>
        <Td><Profile name={data.distributor?.name ?? data.distributor?.company_name} /></Td>
        <Td><Stock available={data.stock} reserved={data.reserved} /></Td>
        <Td isNumeric><Tag minW="40px" colorScheme="teal" children={data.available} /></Td>
        <Td>
            { bonihubStock > 0
                ? <Stock available={bonihubStock} reserved={bonihubReserved} />
                : <Text fontSize="xs" color="gray.400">—</Text>
            }
        </Td>
        <Td isNumeric>
            { bonihubStock > 0
                ? <Tag minW="40px" colorScheme="blue" children={bonihubAvailable} />
                : <Text fontSize="xs" color="gray.400">—</Text>
            }
        </Td>
    </Row>
    )
}
